module.exports = __webpack_public_path__ + "static/media/LS.2425a790.svg";